module.exports = __webpack_public_path__ + "static/castle-e13cf42b9060dce4629468156e64b1e3.svg";